import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { buttonsV2 as Buttons } from '@breezeway/brzw-components';
import PriorityPill from '../priority_pill';
import { TASK_PRIORITY_OPTIONS } from '../../utils/task';

import './priority_updater.scss';

const CLASS_NAME = 'priority-updater';

const PriorityUpdater = ({ isEditable, priority, className, onUpdate }) => {
  const priorityCode = _.get(priority, 'code');
  const priorityName = _.get(priority, 'name');
  const onSelect = code => () => onUpdate(code);
  const options = _.map(TASK_PRIORITY_OPTIONS, ({ code, name }) => ({
    action: onSelect(code),
    icon: code,
    label: name,
    value: code,
  }));
  const pillElement = (
    <PriorityPill
      className={`${CLASS_NAME}__pill`}
      code={priorityCode}
      disabled={!isEditable}
      name={priorityName}
    />
  );

  return (
    <div className={classnames(CLASS_NAME, className)}>
      {isEditable ? (
        <Buttons.QuickActionsButton
          actions={_.reverse(options)}
          className={`${CLASS_NAME}__quick-actions`}
          customButton={pillElement}
          selected={priorityCode}
          size="icon-medium"
          theme="icon-subtle"
        />
      ) : (
        pillElement
      )}
    </div>
  );
};

PriorityUpdater.propTypes = {
  className: PropTypes.string,
  isEditable: PropTypes.bool,
  onUpdate: PropTypes.func,
  priority: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
};

PriorityUpdater.defaultProps = {
  className: '',
  isEditable: true,
};

export default PriorityUpdater;
